export enum LocalStorageKeys {
    Search = "search",
}
